<template>
  <tr>
    <td>
      <label class="page__label">
        <input type="text" class="page__input" v-model="item.name" />
      </label>
    </td>
    <td>
      <label class="page__label">
        <input type="text" class="page__input" v-model="item.price" />
      </label>
    </td>
    <td>
      <button class="btn btn-small" type="button" @click="deleteItem">
        Удалить
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  name: "Table-editable-item",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    deleteItem() {
      this.$emit("deleteItem", this.item.id);
    }
  }
};
</script>
